import { Fragment } from 'react';

import { Link, useLocation } from 'react-router-dom';

import { List, ListItem, ListItemButton, ListItemText, Drawer, DrawerProps, Toolbar, Typography } from '@mui/material';

import { RouteDefintion } from './route-sections';

type NavigationDrawerProps = DrawerProps & {
  sections: RouteDefintion[];
};

const NavigationDrawer = (props: NavigationDrawerProps) => {
  const location = useLocation();
  const { sections, ...others } = props;
  const { ...rest } = others; // Removed staticContext to fix warning

  return (
    <Drawer {...rest}>
      <Toolbar>
        <Typography variant="h6" component="div" color="primary">
          CMS
        </Typography>
      </Toolbar>
      <List>
        {sections.map((section: RouteDefintion) => (
          <Fragment key={section.path}>
            <ListItem disablePadding component={Link} to={section.path} sx={{ color: 'black' }}>
              <ListItemButton selected={location.pathname.replace('/cms/', '') === section.path}>
                <ListItemText primary={section.name} />
              </ListItemButton>
            </ListItem>
            {section.children && (
              <List component="div" disablePadding>
                {section.children?.map((child) => {
                  return (
                    <ListItem key={child.path} disablePadding component={Link} to={child.path} sx={{ color: 'black' }}>
                      <ListItemButton sx={{ pl: 4 }} selected={location.pathname.replace('/cms/', '') === child.path}>
                        <ListItemText primary={child.name} />
                      </ListItemButton>
                    </ListItem>
                  );
                })}
              </List>
            )}
          </Fragment>
        ))}
      </List>
    </Drawer>
  );
};

export default NavigationDrawer;
